import {observer} from "mobx-react";
import type {User} from "../../../../data/models/User";
import {XyiconFeature} from "../../../../generated/api/base";
import {useAppStore} from "../../../../StateManager";
import type {IInputPropsV5} from "../../../widgets/input/clicktoedit/InputUtils";
import {renderItemWithInitials} from "../../sharing/ItemWithInitials";
import {compareUsers, renderUserValue} from "../../../../data/models/field/datatypes/PeopleSingle";
import {PeopleFieldClassName} from "../../input/select/SelectInputV5";
import {MultiSelectInputV5} from "./multi/MultiSelectInputV5";

interface IPeopleMultipleChoiceInputProps extends IInputPropsV5 {
	runOnClickEvenWhenDisabled?: boolean;
}

export const PeopleMultipleChoiceInputV5 = observer((props: IPeopleMultipleChoiceInputProps) => {
	const {value, onChange} = props;
	const appState = useAppStore((state) => state.appState);
	const allUsers = appState.actions.getList<User>(XyiconFeature.User).toSorted(compareUsers);
	const selectedUsers = (value as User[]) ?? [];

	return (
		<MultiSelectInputV5
			pillClassName={PeopleFieldClassName}
			{...props}
			listItemStyle={{height: "40px"}}
			selected={selectedUsers}
			options={allUsers}
			isSameWidth={true}
			renderOptionWhenClosed={(item: User) => renderItemWithInitials(item, "small")}
			renderOptionWhenOpen={(item: User) => renderItemWithInitials(item, "big")}
			stringifyOption={renderUserValue}
			onChange={(users: User[]) => onChange(users.map((u) => u.id))}
		/>
	);
});
